@let obs =
  {
    cart: cart$ | async,
    currentProfile: currentProfile$ | async,
    isBonusSystemEnabled: isBonusSystemEnabled$ | async,
  };

@if (obs.cart) {
  <div class="cart-totals">
    <div *ngIf="obs.cart" class="cart-totals__position-list">
      <div *ngIf="obs.cart.subTotal" class="cart-totals__position">
        <span class="cart-totals__position-label">сумма заказа:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ obs.cart.subTotal.formattedValue }}
        </span>
      </div>

      <div *ngIf="obs.cart.totalDiscounts?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">скидка:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ obs.cart.totalDiscounts.formattedValue }}
        </span>
      </div>

      <div *ngIf="obs.cart.deliveryCost?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">доставка:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ obs.cart.deliveryCost.formattedValue }}
        </span>
      </div>

      <div *ngIf="obs.cart.deliveryServicesCost?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">доп. услуги:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ obs.cart.deliveryServicesCost.formattedValue }}
        </span>
      </div>

      <div
        *ngIf="
          obs.currentProfile &&
          obs.currentProfile.bonusBalance &&
          obs.cart.totalBonusDiscounts &&
          obs.cart.totalBonusDiscounts.value
        "
        class="cart-totals__position"
      >
        <span class="cart-totals__position-label">баллы:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">-{{ obs.cart.totalBonusDiscounts.formattedValue }}</span>
      </div>

      <div *ngIf="obs.cart.totalPrice" class="cart-totals__position">
        <span class="cart-totals__position-label">к оплате:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ obs.cart.totalPrice.formattedValue }}
        </span>
      </div>
    </div>

    <div *ngIf="obs.cart" class="cart-totals__delivery">
      <span>вес/объем: {{ obs.cart.weight }}</span>
      <span>
        кг/{{ obs.cart.volume }} м
        <sup>3</sup>
      </span>
    </div>

    <div
      class="cart-bonus"
      *ngIf="
        obs.currentProfile &&
        obs.currentProfile.bonusBalance &&
        (obs.currentProfile.bonusBalance.value || obs.currentProfile.bonusBalance.value === 0)
      "
    >
      <ng-container *ngIf="!obs.currentProfile.isLegal; else hiddenBonusTpl">
        <sd-checkout-bonus></sd-checkout-bonus>
      </ng-container>
      <ng-template #hiddenBonusTpl>вы можете списать баллы переключившись на физическое лицо</ng-template>
    </div>

    <div class="cart-totals__cashback" *ngIf="obs.isBonusSystemEnabled">
      <span>вернётся баллами:</span>
      <sd-bonus-widget [amount]="bonusAssignedAmount$ | async"></sd-bonus-widget>
    </div>

    <sd-submit-order [fullWidth]="true" class="cart-totals__button-order"></sd-submit-order>

    <div class="cart-totals__terms">
      <p>
        нажимая кнопку “оформить заказ” я подтверждаю согласие с условиями
        <a *ngIf="obs.isBonusSystemEnabled" [routerLink]="'/loyalty_program'">программы лояльности, &ensp;</a>
        <a [routerLink]="'/personal_data'">персональных данных</a>
        и
        <a [routerLink]="'/public_offer'">договором купли-продажи товаров.</a>
      </p>
    </div>
  </div>
}
